<template>
  <img :src="image" alt="" />
</template>

<script>
export default {
  props: {
    storeId: String,
    productId: String
  },
  computed: {
    image() {
      return `${this.$settings.image_url}/store/${this.storeId}/product/images/${this.productId}/thumb.jpg`
    }
  }
}
</script>

<style>
</style>
